import { Component, OnInit, ViewChild, Optional, Inject, HostListener } from '@angular/core';
import { GridOptions, Module } from '@ag-grid-community/all-modules';
import { MatDialog } from '@angular/material/dialog';
import { PershingTranslationService } from '@pershing/pershing-core';
import { PershingGridHeaderComponent, PershingGridControllerComponent, PershingPaginationProperties } from '@pershing/pershing-grid2';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { EdeliveryLabels } from '../../i18n/edelivery-labels';
import { Account } from '../../models/account.model';
import { AccountsResult } from '../../models/accounts-result.model';
import { DialogContainerComponent } from '../dialogContainer/dialog-container.component';
import { EDeliveryService } from '../../services/edelivery.service';
import { EMailService } from '../../services/email.service';
import { Observable, Subscription, combineLatest, BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
// import { debounceTime } from 'rxjs/operators';
import { GridDocumentsCellComponent } from '../gridDocumentsCell/grid-documents-cell.component';
import { PershingError } from '@pershing/pershing-core';

@Component({
  selector: 'edelivery-preference',
  templateUrl: './edelivery-preference.component.html',
  styleUrls: ['./edelivery-preference.component.css']
})
export class EdeliveryPreferenceComponent implements OnInit {

  @ViewChild(PershingGridControllerComponent)
  private pershingGridControllerComponent: PershingGridControllerComponent;
  private pageNumber: number = 1; // Set to 1 as default
  totalRowCount: any = 0;
  isLargeView: boolean = true;
  // @Input('isLargeView') isLargeView: boolean;

  preferencesResponse: Observable<AccountsResult>;
  dataReady: Observable<any>;
  gridOptions: GridOptions;
  public modules: Module[] = [ClientSideRowModelModule];
  response: any;
  // originalResponse: any;
  loading: boolean = false;
  error: boolean = false;
  userFromMyClientView: boolean;
  displayEditAndQuickEnroll: boolean = false;
  tabToNextCell: any;
  errorMessage = 'Due to a system error, the functionality you\'re attempting to use is not available currently. Please try again.';

  emailAddressInfo: any = EdeliveryLabels.EMAIL_ADDRESS_INFO;
  communicationTypes: any = EdeliveryLabels.COMMUNICATION_TYPES;
  QPRDisclaimer: any = EdeliveryLabels.QPR_DISCLAIMER;
  QPRDisclaimerEms: any = EdeliveryLabels.QPR_DISCLAIMER_EMS;

  isUserPendingEnrollment: boolean = false;
  pendingEnrollmentMissingEmails: boolean = false;

  displayQPRDisclaimer: boolean;
  displayCommunicationTypesDisclaimer: boolean;

  // Labels
  pendingPreferencesInfo: any = EdeliveryLabels.PENDING_PREFERENCES;
  pendingPreferencesDocName: any = EdeliveryLabels.DOCUMENT_NAME_PENDING;
  pendingEmailInfo: any = EdeliveryLabels.PENDING_EMAIL;
  edeliveryPreferencesTitle: any = EdeliveryLabels.EDELIVERY_PREFERENCES_TITLE;
  quickEnrollLabel: any = EdeliveryLabels.QUICK_ENROLL_LABEL;
  editLabel: any = EdeliveryLabels.EDIT_LABEL;
  addEmailAddressLabel = EdeliveryLabels.ADD_EMAIL_ADDRESS;
  viewAndSave = EdeliveryLabels.VIEW_AND_SAVE;

  private subscription: Subscription;
  private combinedSubscription: Subscription;
  private errorSubscription: Subscription;
  private _error: BehaviorSubject<PershingError>;
  routeSubscription: Subscription;
  isNXIRequest: boolean  = true;
  showEditButton: boolean  = true;

  constructor(private eDeliveryService: EDeliveryService, private emailService: EMailService, private translate: PershingTranslationService, public dialog: MatDialog,
              private route: ActivatedRoute,
              @Optional() @Inject('AppSettings') appSettings: any
  ) {
    this._error = new BehaviorSubject<PershingError>(null);
    console.log('pending preferences', this.pendingPreferencesInfo);
    if (appSettings.deviceType === 'mobile') {
      this.isLargeView = false;
      this.eDeliveryService.isMobile = true;
    }
    if (this.translate) {
      this.translate.addTranslationFolder('@pershing/edc-edelivery', 'node_modules/@pershing/edc-edelivery/lib');
    }
    this.tabToNextCell = function(params) {};
    this.gridOptions = <GridOptions>{
      rowHeight: 150,
      headerHeight: 46,
      enableColResize: true,
      suppressMovableColumns: true,
      suppressLoadingOverlay: false,
      suppressPaginationPanel: true,
      domLayout: 'autoHeight',
      pagination: true,
      paginationPageSize: 1,
      overlayLoadingTemplate: '<div class="progress-spinner edelivery-Progress_Spinner"></div>',
      defaultColDef: {
        headerComponentFramework: PershingGridHeaderComponent
      },
      columnDefs: this.createColumnDefs(),
      onGridSizeChanged: () => {
        if (this.gridOptions.api) { this.gridOptions.api.sizeColumnsToFit(); }
      },
      onGridReady: ($event) => {
        if (!this.gridOptions.api) {
          this.gridOptions.api = $event.api;
        }
        if (!this.gridOptions.columnApi) {
          this.gridOptions.columnApi = $event.columnApi;
        }
        if (this.gridOptions.api !== undefined && this.response !== undefined) {
          console.log('calling set row data ---- +++ with response: ', this.response);
          this.totalRowCount = this.response.accounts.length;
          let pageRecords = this.getPageRecords();
          let formattedRecords = new AccountsResult(pageRecords);
          this.gridOptions.api.setRowData(this.formatRowData(formattedRecords));
          if (this.pershingGridControllerComponent) {
            this.pershingGridControllerComponent.updatePaginationDisplay(pageRecords.length, this.pageNumber, this.totalRowCount);
          }
        }
        this.gridOptions.api.sizeColumnsToFit(); // Ensure columns are sized to fit the screen
      }
    };
  }

  ngOnInit(): void {
    this.isNXIRequest = this.eDeliveryService.isNXIRequest();
    this.combinedSubscription = combineLatest(this.eDeliveryService.preferencesResponse$, this.emailService.emailresponse$, this.route.queryParamMap, this.eDeliveryService.entitlementsResponse$)
      // .pipe(debounceTime(1000))
      .subscribe(([preferencesResponse, emailResponse, routeResponse, entitlementsResponse]) => {
        console.log('preferencesResponse: ', preferencesResponse, 'emailresponse: ', emailResponse, 'entitlementsResponse: ', entitlementsResponse);
        if (preferencesResponse && emailResponse && routeResponse && entitlementsResponse) {
          if (preferencesResponse.accounts !== undefined && emailResponse.emails !== undefined && routeResponse !== undefined && entitlementsResponse !== undefined) {
            this.response = preferencesResponse;
            // this.originalResponse = JSON.parse(JSON.stringify(this.response));
            this.findPendingEnrollment();
            if (this.gridOptions.api !== undefined) {
              console.log('calling set row data ---- +++ with response: ', this.response);
              this.totalRowCount = this.response.accounts.length;
              let pageRecords = this.getPageRecords();
              let formattedRecords = new AccountsResult(pageRecords);
              this.gridOptions.api.setRowData(this.formatRowData(formattedRecords));
              if (this.pershingGridControllerComponent) {
                this.pershingGridControllerComponent.updatePaginationDisplay(pageRecords.length, this.pageNumber, this.totalRowCount);
              }
              // this.gridOptions.api.setRowData(this.formatRowData(this.response));
              if (this.emailService.updateEmailTriggered === false) {
                this.gridOptions.api.hideOverlay();
              }
              if (this.emailService.emailUpdatedFlag === true && this.emailService.updateEmailTriggered === true) {
                this.gridOptions.api.hideOverlay();
                this.emailService.updateEmailTriggered = false;
                this.emailService.emailUpdatedFlag = false;
              }
            }
            this.displayQPRDisclaimer = this.eDeliveryService.displayQPRDisclaimer;
            this.displayCommunicationTypesDisclaimer = this.eDeliveryService.displayCommunicationTypesDisclaimer;
            if (routeResponse.get('showPopup') === 'true' && this.emailService.showEmailPopup === false && this.eDeliveryService.isQuickEnrollDisplayed === false) {
              this.eDeliveryService.isQuickEnrollDisplayed = true;
              this.quickEnroll();
            }
            if (emailResponse.emails.length > 0) {
              this.displayEditAndQuickEnroll = true;
              this.pendingEnrollmentMissingEmails = false;
            } else {
              this.displayEditAndQuickEnroll = false;
              this.pendingEnrollmentMissingEmails = true;
            }
            if (entitlementsResponse.response.fullEnrollEntitlement === true ) {
              this.showEditButton = true;
            } else {
              this.showEditButton = false;
            }
          }
        }
      },
        error => {
          this.setError(error);
        });

    this.errorSubscription = this.eDeliveryService.error$.subscribe((preferencesErrorResponse) => {
      console.log('preferencesErrorResponse: ', preferencesErrorResponse);
      if (preferencesErrorResponse) {
        this.setError('Due to a system error, the functionality you\'re attempting to use is not available currently. Please try again.');
        this.gridOptions.api.hideOverlay();
      }
    });

    this.eDeliveryService.retrievePreferences();
    this.eDeliveryService.retrieveEntitlements();
    this.eDeliveryService.loading$.subscribe((flag) => {
      if (flag) {
        this.gridOptions.api.showLoadingOverlay();
      }
    });

  //   this.eDeliveryService.emitResetPreferences.subscribe(flagValue => {
  //     if (flagValue) {
  //         this.response = this.originalResponse;
  //         this.totalRowCount = this.response.accounts.length;
  //         let pageRecords = this.getPageRecords();
  //         let formattedRecords = new AccountsResult(pageRecords);
  //         this.gridOptions.api.setRowData(this.formatRowData(formattedRecords));
  //         this.pershingGridControllerComponent.updatePaginationDisplay(pageRecords.length, this.pageNumber);
  //     }
  //  });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.combinedSubscription) {
      this.combinedSubscription.unsubscribe();
    }
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
  }

  onPageChanged(event: PershingPaginationProperties): void {
    this.pageNumber = event.pageNumber;
    this.totalRowCount = this.response.accounts.length;
    let pageRecords = this.getPageRecords();
    let formattedRecords = new AccountsResult(pageRecords);
    this.gridOptions.api.setRowData(this.formatRowData(formattedRecords));
    if (this.pershingGridControllerComponent) {
      this.pershingGridControllerComponent.updatePaginationDisplay(pageRecords.length, this.pageNumber, this.totalRowCount);
    }
  }

  getPageRecords() {
      let currentPage = this.pageNumber;
      let paginationSize = this.gridOptions.paginationPageSize;
      let currentBufferOfRecords = [];
      let start = (currentPage - 1) * paginationSize;
      let end = start;
      for (let i = start; i <= end; i++) {
          currentBufferOfRecords.push(this.response.accounts[i]);
      }
      return currentBufferOfRecords;
  }

  showLoading() {
    this.gridOptions.api.showLoadingOverlay();
  }

  createColumnDefs(): any[] {
    return [
      { headerName: EdeliveryLabels.ACCOUNT, width: 42, field: 'accountNumber', headerClass: 'left-align', cellClass: 'left-align',
        cellRenderer: function(params) {
          return '<b>' + params.value + '</b>';
        }
      },
      {
        headerName: EdeliveryLabels.EDELIVERY_DOCUMENTS, autoHeight: true, field: 'eDeliveryDocuments', headerClass: 'left-align', displayType: 'main',
        cellRendererFramework: GridDocumentsCellComponent
      }
    ];
  }

  // For Grid Accounts View
  formatRowData(response: AccountsResult): any[] {
    let rows: any[] = [];
    for (let i = 0; i < response.accounts.length; i++) {
      let account: Account = response.accounts[i];
      rows.push({
        accountNumber: account.accountNumber, // Name is composed of the document's description.
        eDeliveryDocuments: account
      });
    }
    return rows;
  }

  findPendingEnrollment() {
    for (let i = 0; i < this.response.accounts.length; i++) {
      let documents = this.response.accounts[i].edeliveryDocuments;
      for (let j = 0; j < documents.length; j++) {
        if (documents[j].preferenceType.deliveryPreference === 4 && documents[j].docEligible) {
          this.isUserPendingEnrollment = true;
          return;
        }
      }
    }
    this.isUserPendingEnrollment = false;
  }

  addEmailAddress() {
    this.emailService.addEmailFromPending();
  }

  editPreferences($event?) {
    if ($event) {
      if ($event.code === 'Enter') {
        this.dialog.open(DialogContainerComponent, { panelClass: ['modal', 'edel-EditPreferences'], width: '90vw', id: 'edit' });
      }
    } else {
      this.dialog.open(DialogContainerComponent, { panelClass: ['modal', 'edel-EditPreferences'], width: '90vw', id: 'edit' });
    }
  }

  quickEnroll($event?) {
    if ($event) {
      if ($event.code === 'Enter') {
        this.dialog.open(DialogContainerComponent, { panelClass: ['modal', 'edel-QuickEnroll'], width: '90vw', id: 'quickEnroll' });
      }
    } else {
      this.dialog.open(DialogContainerComponent, { panelClass: ['modal', 'edel-QuickEnroll'], width: '90vw', id: 'quickEnroll' });
    }
  }

  setError(errorMessage: string, errorCode?: string): void {
    this._error.next(new PershingError(errorMessage, 'combinedSubscription', errorCode));
    this.error = true;
  }

  setupTabBehavior($event) {
    if ($event.code === 'Tab') {
      $event.stopPropagation();
    }
  }
  @HostListener('document:portal.nxiOneClickAcceptEvent', ['$event'])
  oneClickAcceptEventHandle(event: any) {
      if (location.href.includes('default-settings')) {
        this.eDeliveryService.retrievePreferences();
      }
  }
}
